import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'kt-grafica-estadistica-medidor',
  templateUrl: './grafica-estadistica-medidor.component.html',
  styleUrls: ['./grafica-estadistica-medidor.component.scss']
})
export class GraficaEstadisticaMedidorComponent implements OnInit {
  public dataGrafica = []
  public legend: boolean = true;
  public showLabels: boolean = true;
  public animations: boolean = true;
  public xAxis: boolean = true;
  public yAxis: boolean = true;
  public showYAxisLabel: boolean = false;
  public showXAxisLabel: boolean = false;
  public timeline: boolean = true;
  public autoScale: boolean = true;
  public showGrafica: boolean = false;

  public legendTitle: string = ""

  colorScheme = {
    domain: ['#166BA2', '#5AA454']
  };

  constructor(public dialog: MatDialog,
    private datepipe: DatePipe,
    public dialogRef: MatDialogRef<GraficaEstadisticaMedidorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    const gasto = this.obtenerGraficaGasto();
    const totalizador = this.obtenerGraficaTotalizador();

    this.dataGrafica.push(gasto);
    this.dataGrafica.push(totalizador);
  }

  obtenerGraficaGasto() {
    let array = []

    for (let d of this.data) {
      let gasto = d.gasto
      let fecha = new Date(d.fechaHora)
      
      const aux = { "name": fecha, "value": gasto.toFixed(4) }
      array.push(aux)
    
    }

    const dataGraficaGasto = {
      "name": "Gasto m3/h",
      "series": array
    }    
    return dataGraficaGasto
  }


  obtenerGraficaTotalizador() {
    let array = []

    for (let d of this.data) {
      let totalizador = d.totalizador
      let fecha = new Date(d.fechaHora)
      const aux = { "name": fecha, "value": totalizador.toFixed(4) }
      array.push(aux)
    }

    const dataGraficaTotalizador = {
      "name": "Totalizador m3",
      "series":  array
    }

    return dataGraficaTotalizador
  }

  public minimizarPopup() {
    this.dialogRef.addPanelClass('displayNone');
  }

  public maximizarPopup() {
    this.dialogRef.removePanelClass('displayNone');
  }

  public cerrarPopup() {
    this.dialogRef.close();
  }

  public tickFormatting(date: any) {
    const options = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'

    };
    if (date.constructor.name === 'Date') {
      return date.toLocaleDateString('en-US', options);
    }
    return date.toLocaleString('en-US', options);
  }

  onSelect(data): void {
    //console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
    //console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data): void {
    //console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }

}
